import type { TFunction } from 'i18next'
import { useParams } from 'src/lib/hooks'
import { treatExternalLocale } from 'src/lib/utils'

import { initI18n } from './i18n'

const useLanguage = (): Promise<TFunction<'translation', undefined>> => {
  const { lang } = useParams()
  const locale = treatExternalLocale(lang)

  return initI18n(locale)
}

export default useLanguage
